import { HelmetProvider } from "react-helmet-async";
import { ChakraProvider, createStandaloneToast } from "@chakra-ui/react";
import { theme } from "./theme/Theme";
import { AppRoutes } from "./router/Router";
import { ModalProvider } from "../contexts/ModalContext";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { queryClient } from "../api/QueryClient";

const { ToastContainer, toast } = createStandaloneToast(theme);

// Add the standalone toast to window so we can use it outside of react components
declare global {
  interface Window {
    toast: typeof toast;
  }
}
window.toast = toast;

const App = (): JSX.Element => {
  const persister = createSyncStoragePersister({
    storage: window.localStorage,
  });

  return (
    <PersistQueryClientProvider persistOptions={{ persister }} client={queryClient}>
      <ChakraProvider
        theme={theme}
        toastOptions={{
          defaultOptions: {
            position: "top",
            isClosable: true,
            duration: 5000,
          },
        }}
      >
        <HelmetProvider>
          <ToastContainer />
          <ModalProvider>
            <AppRoutes />
          </ModalProvider>
        </HelmetProvider>
      </ChakraProvider>
      <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
    </PersistQueryClientProvider>
  );
};

export default App;
